import { I18n } from '@affine/i18n';
import { css, html, nothing } from 'lit';

import { AffineIcon } from '../_common/icons';
import {
  aiChatHeadingTypography,
  aiChatStatusTypography,
} from '../styles/ai-chat-typography';

export const AIChatEmptyStateStyles = css`
  .ai-chat-empty-state-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .ai-chat-empty-state-title {
    ${aiChatHeadingTypography}
    color: var(--streamlain-v2-text-primary);
  }

  .ai-chat-empty-state-title[data-loading='true'] {
    ${aiChatStatusTypography}
    color: var(--streamlain-v2-text-secondary);
  }
`;

export function renderAIChatEmptyStateContent({
  isLoading = false,
  panelTestIds = false,
}: {
  isLoading?: boolean;
  panelTestIds?: boolean;
} = {}) {
  return html`
    <div class="ai-chat-empty-state-content">
      ${AffineIcon(
        isLoading
          ? 'var(--streamlain-v2-icon-secondary)'
          : 'var(--streamlain-v2-brand-primary)'
      )}
      <div class="ai-chat-empty-state-title" data-loading=${isLoading}>
        ${isLoading
          ? html`<span
              data-testid=${panelTestIds ? 'chat-panel-loading-state' : nothing}
              >${I18n.t('com.streamlain.ai.chat.loading-history')}</span
            >`
          : html`<span
              data-testid=${panelTestIds ? 'chat-panel-empty-state' : nothing}
              >${I18n.t('com.streamlain.ai.chat.empty-title')}</span
            >`}
      </div>
    </div>
  `;
}
